var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 0C5.373 0 0 5.373 0 12C0 18.627 5.373 24 12 24C18.627 24 24 18.627 24 12C24 5.373 18.627 0 12 0ZM10.75 17.292L6.25 12.928L8.107 11.07L10.75 13.576L16.393 7.792L18.25 9.649L10.75 17.292Z","fill":"#45B19E"}));
}

Checkmark.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
